import logo from "./logo.svg";
import VenderPaymentCreation from "./Components/Invoice/VenderPaymentCreation";
import AppRoutes from "./Components/Routes/AppRoutes";
import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import { jwtDecode } from "jwt-decode";

function App() {
 
  return (
    <div className="App">
      <AppRoutes  />
    </div>
  );
}

export default App;
